// import colors from 'style-utils/colors';

const defaultMargin = '24px auto';

const infoBannerTheme = {
  display: 'flex',
  background: '#F0F5FF',
  boxShadow: 'inset 0px -2px 0px #67aaf97f',
  iconSpacing: '8px',
  borderRadius: '5px',
  zIndex: '0',
  mobile: {
    margin: defaultMargin,
    padding: '8px',
  },
  tablet: {
    margin: defaultMargin,
  },
  desktop: {
    margin: defaultMargin,
  },
};

export default infoBannerTheme;
